import { Box, Card, Divider, Hidden, Skeleton, Typography } from '@mui/material';
import Label from './Label.tsx';
import { useTranslation } from 'react-i18next';
import { IPackage } from '../../interfaces/studio.ts';
import { ReactNode, useContext, Fragment } from 'react';
import { UserContext } from '../../contexts/UserContext.tsx';
interface IProps {
	data: IPackage | undefined;
	children?: ReactNode;
}
export default function HeaderStudio({ data, children }: IProps) {
	const { user }: any = useContext(UserContext);
	const { t } = useTranslation();

	const box1Demo = [
		{ label: t('category'), value: user?.is_admin ? 'category_title' : 'category' },
		{ label: t('release-platform'), value: user?.is_admin ? 'media_title' : 'media' },
		{ label: t('content_type'), value: user?.is_admin ? 'content_title' : 'content_type' },
		{ label: t('photo_maker'), value: user?.is_admin ? 'company_name' : 'company_name' },
		{ label: t('quality'), value: user?.is_admin ? 'quality_title' : 'quality' },
	];

	return (
		<>
			<Card className={'flex flex-col flex-wrap justify-between gap-3 px-6 pb-6 pt-4 md:flex-row md:gap-0'}>
				{box1Demo?.map((item, index) => (
					<Fragment key={index}>
						<Hidden lgDown>{index !== 0 && <Divider className={'w-0.5 bg-grey-300 md:h-20'} />}</Hidden>
						<Box className="mx-2 flex items-center justify-between gap-4 md:basis-1/6 md:flex-col">
							<Label text={item.label} />
							{data === undefined ? <Skeleton className={'w-full'} /> : <Typography className={'mb-4 text-text-secondary'}>{data?.[item.value as keyof typeof data]}</Typography>}
						</Box>
					</Fragment>
				))}
			</Card>
			<Card className={'flex flex-col gap-6 p-6'}>
				<Box className="flex">
					<Box className={'flex w-full items-center gap-6'}>
						<Box className={'flex basis-2/12'}>
							<Label text={t('necessary_materials')} />
						</Box>
						<Box className={'flex basis-10/12'}>{data === undefined ? <Skeleton className={'w-full'} /> : <Typography className={'text-sm text-text-secondary'}>{data?.requirement_title}</Typography>}</Box>
					</Box>
					<Box>{children}</Box>
				</Box>
				<Box className="flex">
					<Box className={'flex w-full items-start gap-6'}>
						<Box className={'flex basis-2/12'}>
							<Label text={t('description')} />
						</Box>
						<Box className={'flex basis-10/12'}>{data === undefined ? <Skeleton className={'w-full'} /> : <Typography className={'text-sm text-text-secondary'}>{data?.requirement_description}</Typography>}</Box>
					</Box>
				</Box>
			</Card>
		</>
	);
}
